import type { EmojiData } from './types';

export function makeDefault(): EmojiData {
  return {
    group: 'smileys',
    id: '10',
    variant: 'stamp',
  };
}
